export default {
  props: {
    defaultedValueResult: null,
    waves: { type: Array, required: true }
  },

  methods: {
    findQuarter(kpi, wave) {
      if(!kpi || !kpi.SurveyWave) {
        return null;
      }
      return _.find(kpi.SurveyWave, function(x) { return x.Year === wave.year && _.includes(x.Name, wave.name); });
    },

    getValue(wave) {
      let item = this.findQuarter(this.kpi, wave);
      return item ? item.Result : this.defaultedValueResult;
    }
  }
};
